var Location = {
    BE: "BE",
    ES: "ES",
    FR: "FR"
};

module.exports = Location;



// WEBPACK FOOTER //
// ./src/enums/Location.js